import { render, staticRenderFns } from "./userDashboardNutrition.vue?vue&type=template&id=492be30e&scoped=true"
import script from "./userDashboardNutrition.vue?vue&type=script&lang=js"
export * from "./userDashboardNutrition.vue?vue&type=script&lang=js"
import style0 from "./userDashboardNutrition.vue?vue&type=style&index=0&id=492be30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492be30e",
  null
  
)

export default component.exports